var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "japan-corporation-update-page" } }, [
    _c("div", { staticClass: "item" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.corporateNumber,
              expression: "formData.corporateNumber"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|length:13",
              expression: "'required|length:13'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "corporateNumber",
            autocomplete: "off",
            placeholder: "数字13桁",
            "data-vv-as": "法人番号"
          },
          domProps: { value: _vm.formData.corporateNumber },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "corporateNumber", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("corporateNumber"),
                expression: "errors.has('corporateNumber')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("corporateNumber")))]
        ),
        _vm._v(" "),
        _vm._m(1)
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.invoiceRegistrationKbn,
                expression: "formData.invoiceRegistrationKbn"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "form-control",
            attrs: {
              name: "invoiceRegistrationKbn",
              "data-vv-as": "インボイス登録番号取得区分"
            },
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.formData,
                    "invoiceRegistrationKbn",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
                function($event) {
                  _vm.changeInvoiceRegistrationKbn()
                }
              ]
            }
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v("選択してください")
            ]),
            _vm._v(" "),
            _vm._l(_vm.invoiceRegistrationKbnOptions, function(
              invoiceRegistrationKbnOption
            ) {
              return _c(
                "option",
                {
                  key:
                    "invoiceRegistrationKbn-" + invoiceRegistrationKbnOption.id,
                  domProps: { value: invoiceRegistrationKbnOption.id }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(invoiceRegistrationKbnOption.name) +
                      "\n        "
                  )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("invoiceRegistrationKbn"),
                expression: "errors.has('invoiceRegistrationKbn')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("invoiceRegistrationKbn")))]
        ),
        _vm._v(" "),
        _vm.showInvoiceRegistrationDate
          ? _c("div", [
              _c("div", { staticClass: "m-t" }, [_vm._v("取得予定日")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("date-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "invoiceRegistrationDate",
                    attrs: {
                      placeholder: "例) yyyy/mm/dd",
                      format: "YYYY/MM/DD",
                      name: "invoiceRegistrationDate",
                      "data-vv-as": "取得予定日",
                      "input-attr": {
                        class: "invoice-registration-date form-control"
                      },
                      lang: _vm.lang,
                      "not-before": _vm.todayFormatDate
                    },
                    model: {
                      value: _vm.formData.invoiceRegistrationDate,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "invoiceRegistrationDate", $$v)
                      },
                      expression: "formData.invoiceRegistrationDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("invoiceRegistrationDate"),
                      expression: "errors.has('invoiceRegistrationDate')"
                    }
                  ],
                  staticClass: "text-danger"
                },
                [
                  _vm._v(
                    "※" + _vm._s(_vm.errors.first("invoiceRegistrationDate"))
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showInvoiceRegistrationNumber
          ? _c("div", [
              _c("div", { staticClass: "m-t" }, [_vm._v("登録番号")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.invoiceRegistrationNumber,
                    expression: "formData.invoiceRegistrationNumber"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|length:14",
                    expression: "'required|length:14'"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "invoiceRegistrationNumber",
                  autocomplete: "off",
                  placeholder: "T + 数字13桁",
                  "data-vv-as": "登録番号"
                },
                domProps: { value: _vm.formData.invoiceRegistrationNumber },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.formData,
                      "invoiceRegistrationNumber",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("invoiceRegistrationNumber"),
                      expression: "errors.has('invoiceRegistrationNumber')"
                    }
                  ],
                  staticClass: "text-danger"
                },
                [
                  _vm._v(
                    "※" + _vm._s(_vm.errors.first("invoiceRegistrationNumber"))
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(3)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "input-description" }, [
          _vm._v("\n        ※セルモン設定画面からもご登録が可能です。\n      ")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyName,
              expression: "formData.companyName"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:100",
              expression: "'required|max:100'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyName",
            autocomplete: "off",
            placeholder: "例) 株式会社 セルモン",
            "data-vv-as": "[法人] 法人名"
          },
          domProps: { value: _vm.formData.companyName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "companyName", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyName"),
                expression: "errors.has('companyName')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyName")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyNameEiji,
              expression: "formData.companyNameEiji"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:200",
              expression: "'required|max:200'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyNameEiji",
            autocomplete: "off",
            placeholder: "例) カブシキガイシャ セルモン",
            "data-vv-as": "[法人] 法人名フリガナ、または英字"
          },
          domProps: { value: _vm.formData.companyNameEiji },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "companyNameEiji", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyNameEiji"),
                expression: "errors.has('companyNameEiji')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyNameEiji")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyRepresentativeName,
              expression: "formData.companyRepresentativeName"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:100",
              expression: "'required|max:100'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyRepresentativeName",
            autocomplete: "off",
            placeholder: "例) セルモン 太郎",
            "data-vv-as": "[法人] 代表者名"
          },
          domProps: { value: _vm.formData.companyRepresentativeName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.formData,
                "companyRepresentativeName",
                $event.target.value
              )
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyRepresentativeName"),
                expression: "errors.has('companyRepresentativeName')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyRepresentativeName")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyRepresentativeNameEiji,
              expression: "formData.companyRepresentativeNameEiji"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:200",
              expression: "'required|max:200'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyRepresentativeNameEiji",
            autocomplete: "off",
            placeholder: "例) セルモン タロウ",
            "data-vv-as": "[法人] 代表者名フリガナ、または英字"
          },
          domProps: { value: _vm.formData.companyRepresentativeNameEiji },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.formData,
                "companyRepresentativeNameEiji",
                $event.target.value
              )
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyRepresentativeNameEiji"),
                expression: "errors.has('companyRepresentativeNameEiji')"
              }
            ],
            staticClass: "text-danger"
          },
          [
            _vm._v(
              "※" + _vm._s(_vm.errors.first("companyRepresentativeNameEiji"))
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyZipCode,
              expression: "formData.companyZipCode"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|numeric|min:1|max:7",
              expression: "'required|numeric|min:1|max:7'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyZipCode",
            autocomplete: "off",
            placeholder: "例) 1234567（ハイフンなし）",
            "data-vv-as": "[法人] 郵便番号"
          },
          domProps: { value: _vm.formData.companyZipCode },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "companyZipCode", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyZipCode"),
                expression: "errors.has('companyZipCode')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyZipCode")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.companyStateCode,
                expression: "formData.companyStateCode"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "form-control",
            attrs: {
              name: "companyStateCode",
              "data-vv-as": "[法人] 都道府県"
            },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.formData,
                  "companyStateCode",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v("選択してください")
            ]),
            _vm._v(" "),
            _vm._l(_vm.stateList, function(corState) {
              return _c(
                "option",
                {
                  key: "cor-" + corState.id,
                  domProps: { value: corState.state_code }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(corState.state_name) + "\n        "
                  )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyStateCode"),
                expression: "errors.has('companyStateCode')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyStateCode")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(10),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyAddress,
              expression: "formData.companyAddress"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:400",
              expression: "'required|max:400'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyAddress",
            autocomplete: "off",
            placeholder: "例) 東京都新宿区西新宿２丁目８−１",
            "data-vv-as": "[法人] 住所"
          },
          domProps: { value: _vm.formData.companyAddress },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "companyAddress", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyAddress"),
                expression: "errors.has('companyAddress')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyAddress")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(11),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyAddressBuilding,
              expression: "formData.companyAddressBuilding"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "max:100",
              expression: "'max:100'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyAddressBuilding",
            autocomplete: "off",
            placeholder: "例) セルモンタワー",
            "data-vv-as": "[法人] 建物名"
          },
          domProps: { value: _vm.formData.companyAddressBuilding },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.formData,
                "companyAddressBuilding",
                $event.target.value
              )
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyAddressBuilding"),
                expression: "errors.has('companyAddressBuilding')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyAddressBuilding")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(12),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyTellNo,
              expression: "formData.companyTellNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:20",
              expression: "'required|max:20'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyTellNo",
            autocomplete: "off",
            placeholder: "例) 03-1234-5678",
            "data-vv-as": "[法人] 代表電話番号"
          },
          domProps: { value: _vm.formData.companyTellNo },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "companyTellNo", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyTellNo"),
                expression: "errors.has('companyTellNo')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyTellNo")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(13),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.companyHpUrl,
              expression: "formData.companyHpUrl"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "max:400",
              expression: "'max:400'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "companyHpUrl",
            autocomplete: "off",
            placeholder: "例) https://ssc.salemonster.jp/",
            "data-vv-as": "[法人] 自社ホームページURL"
          },
          domProps: { value: _vm.formData.companyHpUrl },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "companyHpUrl", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("companyHpUrl"),
                expression: "errors.has('companyHpUrl')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("companyHpUrl")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(14),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.sellerName,
              expression: "formData.sellerName"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:100",
              expression: "'required|max:100'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "sellerName",
            autocomplete: "off",
            placeholder: "例) セルモン 花子",
            "data-vv-as": "[担当] 担当者氏名"
          },
          domProps: { value: _vm.formData.sellerName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "sellerName", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("sellerName"),
                expression: "errors.has('sellerName')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("sellerName")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(15),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.sellerNameEiji,
              expression: "formData.sellerNameEiji"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:200",
              expression: "'required|max:200'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "sellerNameEiji",
            autocomplete: "off",
            placeholder: "例) セルモン ハナコ",
            "data-vv-as": "[担当] 担当者氏名フリガナ、または英字"
          },
          domProps: { value: _vm.formData.sellerNameEiji },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "sellerNameEiji", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("sellerNameEiji"),
                expression: "errors.has('sellerNameEiji')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("sellerNameEiji")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(16),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.zipCode,
              expression: "formData.zipCode"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|numeric|min:1|max:7",
              expression: "'required|numeric|min:1|max:7'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "zipCode",
            autocomplete: "off",
            placeholder: "例) 1234567（ハイフンなし）",
            "data-vv-as": "[担当] 郵便番号"
          },
          domProps: { value: _vm.formData.zipCode },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "zipCode", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("zipCode"),
                expression: "errors.has('zipCode')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("zipCode")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(17),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.stateCode,
                expression: "formData.stateCode"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "form-control",
            attrs: { name: "stateCode", "data-vv-as": "[担当] 都道府県" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.formData,
                  "stateCode",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v("選択してください")
            ]),
            _vm._v(" "),
            _vm._l(_vm.stateList, function(resState) {
              return _c(
                "option",
                {
                  key: "res-" + resState.id,
                  domProps: { value: resState.state_code }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(resState.state_name) + "\n        "
                  )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("stateCode"),
                expression: "errors.has('stateCode')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("stateCode")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(18),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.address,
              expression: "formData.address"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:400",
              expression: "'required|max:400'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "address",
            autocomplete: "off",
            placeholder: "例) 東京都新宿区西新宿２丁目８−１",
            "data-vv-as": "[担当] 住所"
          },
          domProps: { value: _vm.formData.address },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "address", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("address"),
                expression: "errors.has('address')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("address")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(19),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.addressBuilding,
              expression: "formData.addressBuilding"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "max:100",
              expression: "'max:100'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "addressBuilding",
            autocomplete: "off",
            placeholder: "例) セルモンタワー",
            "data-vv-as": "[担当] 建物名"
          },
          domProps: { value: _vm.formData.addressBuilding },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "addressBuilding", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("addressBuilding"),
                expression: "errors.has('addressBuilding')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("addressBuilding")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(20),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.telNo,
              expression: "formData.telNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|max:20",
              expression: "'required|max:20'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "telNo",
            autocomplete: "off",
            placeholder: "例) 03-1234-5678",
            "data-vv-as": "[担当] 電話番号"
          },
          domProps: { value: _vm.formData.telNo },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "telNo", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("telNo"),
                expression: "errors.has('telNo')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("telNo")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _vm._m(21),
      _vm._v(" "),
      _c("div", { staticClass: "item-content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.dept,
              expression: "formData.dept"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "max:45",
              expression: "'max:45'"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "dept",
            autocomplete: "off",
            placeholder: "例) セルモン一部",
            "data-vv-as": "[担当] 所属部署名"
          },
          domProps: { value: _vm.formData.dept },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "dept", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("dept"),
                expression: "errors.has('dept')"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v("※" + _vm._s(_vm.errors.first("dept")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mr-t-10" }, [
      _c("a", {
        attrs: { href: "javascript:void(0)" },
        domProps: { innerHTML: _vm._s("< 戻る") },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.$emit("back")
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-step-action" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-register",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.handleSubmit()
            }
          }
        },
        [_vm._v("登録する")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("法人番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-note" }, [
      _vm._v("\n        法人番号を確認したい場合は、"),
      _c(
        "a",
        {
          staticClass: "text--underline",
          attrs: {
            href: "https://www.houjin-bangou.nta.go.jp/",
            target: "_blank"
          }
        },
        [_vm._v("こちら")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [
        _vm._v("インボイス登録番号"),
        _c("br"),
        _vm._v("（適格請求書発行事業者登録番号）")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-note pd-l-10" }, [
      _vm._v("\n          インボイス登録番号を確認したい場合は、"),
      _c(
        "a",
        {
          staticClass: "text--underline",
          attrs: {
            href: "https://www.invoice-kohyo.nta.go.jp/",
            target: "_blank"
          }
        },
        [_vm._v("こちら")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[法人] 法人名")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [
        _vm._v("[法人] 法人名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[法人] 代表者名")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [
        _vm._v("[法人] 代表者名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[法人] 郵便番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[法人] 都道府県")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[法人] 住所")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[法人] 建物名")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-any" }, [_vm._v("任意")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [
        _vm._v("[法人] 代表電話番号")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [
        _vm._v("[法人] 自社ホームページURL")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label-any" }, [_vm._v("任意")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 担当者氏名")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [
        _vm._v("[担当] 担当者氏名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 郵便番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 都道府県")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 住所")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 建物名")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-any" }, [_vm._v("任意")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 電話番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("[担当] 所属部署名")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-any" }, [_vm._v("任意")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73bd7f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73bd7f74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/updateRegisterInfo/JapanCorporation.vue
// module id = null
// module chunks = 